/**
 * 混合搜索
 * 
 * @Author: Focci
 * @Date: 2023-09-29 08:53:09
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-29 08:53:09
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { houseSearchType } from '@lib/config'
import { Button } from '@comp/material'
import { useTranslations } from 'next-intl'
import { useState, useCallback } from 'react'
import ZoneSchool from './zone-school'
import CombineAutocomplete from './CombineAutocomplete'
import { uniqOptions, handleSearchItemClick } from './lib'

export { handleSearchItemClick }

export default function Combine({
  value = [],
  onChange = () => {},
  wraperClassName = 'w-full',
  type,
  optionPrevFilter,
  autocompleteProps = {},
  module, // 选择地区与学校弹出框 要显示的模块
  single, // 是否单选
  children,
}) {
  const ts = useTranslations('search')
  const tt = useTranslations('track')
  const [open, setOpen] = useState(false)

  // 选择地区与学校
  const handleZoneSchoolChange = useCallback(({ data }) => {
    const tmp = uniqOptions([...value, ...data])
    onChange(null, tmp, 'selectOption', { isZoneSchoolPicker: true })
    setOpen(false)
  }, [onChange, value])

  const isAUEspecial = type === houseSearchType.estimate
  
  return (
    <div className={clsx(['max-w-full flex', wraperClassName])}>
      <CombineAutocomplete
        value={value}
        type={type}
        onChange={onChange}
        optionPrevFilter={optionPrevFilter}
        placeholder={isAUEspecial ? tt('searchByTypeAddr') : ts('searchInputPlaceholder')}
        suffix={
          !isAUEspecial && (
            <div className="ml-1">
              <Button
                className="!inline-flex"
                variant="outlined"
                onClick={() => setOpen(true)}
              >
                {module === 'district' ? ts('district') : ts('selectDistrictSchool')}
              </Button>
            </div>
          )
        }
        {...autocompleteProps}
      />
      {children}
      {open && (
        <ZoneSchool
          open={open}
          single={single}
          module={module}
          onClose={() => setOpen(false)}
          onSubmit={handleZoneSchoolChange}
        />
      )}
    </div>
  )
}

Combine.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  wraperClassName: PropTypes.string,
  autocompleteProps: PropTypes.object,
  module: PropTypes.string,
  single: PropTypes.bool,
  children: PropTypes.node,
}
